import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { CheckBoxPropsTypes } from "../CheckBoxPropsTypes";
import "../SCSS/styles.css";

function CheckBox({
  handleMultiChange,
  questionObjVariable,
  questionId,
  surveyAnswers,
  isPreview,
  surveyAnswersInfo,
  handleChangeOtherOptionTextArea,
  othersOption,
}: CheckBoxPropsTypes) {
  return (
    <>
      {questionObjVariable?.[questionId]?.optionInfo?.optionOrder?.map(
        (optn) => {
          return (
            <div key={optn} className="supplier-view-check-box-cover">
              <input
                disabled={
                  isPreview ||
                  surveyAnswers?.[questionId!]?.notApplicableInfo
                    ?.isNotApplicable
                }
                type="checkbox"
                className="supplier-view-input-checkbox"
                onChange={(e) => {
                  surveyAnswersInfo?.surveyStatus !==
                    EnumSurveyAnswerStatus?.COMPLETED &&
                    !surveyAnswers?.[questionId!]?.notApplicableInfo
                      ?.isNotApplicable &&
                    handleMultiChange!(
                      e,
                      questionId,
                      optn,
                      questionObjVariable?.[questionId]?.optionInfo?.optionObj[
                        optn
                      ]?.optionName,
                      Number(
                        questionObjVariable?.[questionId]?.optionInfo
                          ?.optionObj[optn]?.weightage
                      )
                    );
                }}
                checked={
                  surveyAnswers[questionId]?.val?.[optn]?.optionId ?? false
                }
              />
              <label
                style={{
                  paddingLeft: "10px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {
                  questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[
                    optn
                  ]?.optionName
                }
              </label>
            </div>
          );
        }
      )}

      <>
        {surveyAnswers?.[questionId]?.isOthersChecked && (
          <>
            <div className="supplier-view-check-box-enable-others-text-area-cover">
              <textarea
                className={`supplier-view-check-box-enable-others-text-area ${
                  surveyAnswers[questionId].val[othersOption!.optionId]
                    .othersAnswer &&
                  surveyAnswersInfo?.surveyStatus !==
                    EnumSurveyAnswerStatus?.COMPLETED
                    ? "blue"
                    : "gray"
                }`}
                onChange={(event) => {
                  surveyAnswersInfo?.surveyStatus !==
                    EnumSurveyAnswerStatus?.COMPLETED &&
                    !surveyAnswers?.[questionId!]?.notApplicableInfo
                      ?.isNotApplicable &&
                    handleChangeOtherOptionTextArea!(
                      event,
                      othersOption!.optionId
                    );
                }}
                value={
                  surveyAnswers[questionId].val[othersOption!.optionId]
                    .othersAnswer ?? ""
                }
                disabled={
                  isPreview ||
                  surveyAnswersInfo?.surveyStatus ===
                    EnumSurveyAnswerStatus?.COMPLETED
                }
                placeholder="Please Specify"
              />
            </div>
            {surveyAnswers[questionId]?.isOthersChecked &&
              questionObjVariable?.[questionId].validation.mandatory
                .isMandatory &&
              !surveyAnswers[questionId].val[othersOption!.optionId]
                .othersAnswer && (
                <span className="enable-others-text-error-cover">
                  Please specify others once enabled.
                </span>
              )}
          </>
        )}
      </>
    </>
  );
}

export default CheckBox;
